import { hold as holdImage } from "./api.ts";

export interface PhotoUrls {
  photoUrl: string;
  backPhotoUrl: string | null;
}

// Signed photo links last 600 s, so each garment's photos are downloaded once into blob: URLs, and every later copy
// of the catalog gets the held ones back.
export function photoCache() {
  const held = new Map<string, PhotoUrls>();
  return {
    // Puts photos already held onto a freshly fetched catalog's garments.
    reuse(garments: ({ id: string } & PhotoUrls)[]): void {
      for (const g of garments) {
        const urls = held.get(g.id);
        if (urls) Object.assign(g, urls);
      }
    },
    // Downloads the photos of these garments that are not held yet, and returns the ids whose photos did not load.
    // Those keep their signed links (the preview can still show them) and are not remembered, so the next try fetches again.
    async hold(garments: ({ id: string } & PhotoUrls)[]): Promise<string[]> {
      const failed: string[] = [];
      await Promise.all(garments.filter((g) => !held.has(g.id)).map(async (g) => {
        const urls = { photoUrl: await holdImage(g.photoUrl), backPhotoUrl: g.backPhotoUrl ? await holdImage(g.backPhotoUrl) : null };
        if (!urls.photoUrl.startsWith("blob:") || (urls.backPhotoUrl !== null && !urls.backPhotoUrl.startsWith("blob:"))) {
          failed.push(g.id);
          return;
        }
        held.set(g.id, urls);
        Object.assign(g, urls);
      }));
      return failed;
    },
  };
}
